// src/services/dataService.js
export class DataService {
	// Environment configuration
	static ENVIRONMENTS = {
		prod: {
			appData: {
				url: 'https://ktl-p-euw-etl-fnc.azurewebsites.net',
				key: 't5T4U32Ex9kpG2vQUmIwUlsoZmtMPwjqZB2LpfGy2UuXAzFuM7fw9A==',
			},
			travelday: {
				url: 'https://rvu-api.kogenta.com/api/travelday',
				key: 'afjLKb98Cdkrek94Rucn8fGN6q2I4NlBvgvgo0nKfPXBAzFuR5Dfpw==',
			},
			rvu: {
				url: 'https://rvu-api.kogenta.com',
			},
		},
		test: {
			appData: {
				url: 'https://ktl-p-euw-etl-fnc.azurewebsites.net',
				key: 't5T4U32Ex9kpG2vQUmIwUlsoZmtMPwjqZB2LpfGy2UuXAzFuM7fw9A==',
			},
			travelday: {
				url: 'https://rvu-api-test.kogenta.com/api/travelday',
				key: 'afjLKb98Cdkrek94Rucn8fGN6q2I4NlBvgvgo0nKfPXBAzFuR5Dfpw==',
			},
			rvu: {
				url: 'https://rvu-api-test.kogenta.com',
			},
		},
	}

	constructor() {
		this.currentEnv = this.determineEnvironment()
	}

	// Determine environment from URL or default to 'prod'
	determineEnvironment() {
		// If url contains test then use test environment
		if (window.location.href.includes('test')) {
			console.warn('Using environment: test')
			return 'test'
		}
		console.warn('Using default environment: prod')
		return 'prod'
	}

	// Get current environment endpoints
	get ENDPOINTS() {
		return DataService.ENVIRONMENTS[this.currentEnv]
	}

	async getAppData_OLD(id, from, to) {
		console.warn('Fetching app data for ID:', id, 'from:', from, 'to:', to)
		const url = `${this.ENDPOINTS.appData.url}/api/data?os=ios&appInstallationId=${id}&dateFrom=${from}&dateTo=${to}`
		const response = await fetch(url, {
			headers: {
				'x-functions-key': this.ENDPOINTS.appData.key,
				'Content-Type': 'application/json',
			},
		})
		return await response.text()
	}

	getConnectApiKey() {
		const LS_KEY = 'connect_api_key'
		const urlParams = new URLSearchParams(window.location.search)
		const keyFromUrl = urlParams.get('key')
		if (keyFromUrl) {
			localStorage.setItem(LS_KEY, keyFromUrl)
			return keyFromUrl
		}
		return localStorage.getItem(LS_KEY)
	}

	async getAppData(id, from, to) {
		const API_URL = 'https://connect.kogenta.com/api/public/v1/workflows'
		const WORKFLOW_ID = 'c6abc6b1-67eb-4a91-899c-75a2f53d9ad6-px7esu'
		const API_KEY = this.getConnectApiKey()
		if (!API_KEY) {
			console.error('dataService: No connect API key found. Provide ?key= in the URL.')
			return null
		}
		var url = API_URL + '/' + WORKFLOW_ID + '/execute?app_uuid=' + id + '&from_date=' + from + '&to_date=' + to
		const response = await fetch(url, {
			headers: {
				Authorization: 'Bearer ' + API_KEY,
				'Content-Type': 'application/json',
			},
		})
		const responseData = await response.json()
		const jsonData = responseData?.data?.results?.query_1?.data?.[0]?.data || null
		return jsonData
	}

	handleSurveyDefinitions(data) {
		// Correct known bad coordinate
		if (data?.variables?.places?.length > 0 && data?.variables?.places[0]?.address === 'Veslejordet 14, 2008 Fjerdingby') {
			data.variables.places[0].latitude = 59.905426
			data.variables.places[0].longitude = 11.099289
		}
	}

	async getSurveyDefinitions(survey_id, resp_id, ignoreCache = true, callback) {
		const cacheKey = `survey_definitions`
		const cachedData = localStorage.getItem(cacheKey)
		// If we have cached data
		if (cachedData) {
			const parsedData = JSON.parse(cachedData)
			// Start refresh in background
			this.getSurveyDefinitionsInternal(survey_id, resp_id, ignoreCache).then((updatedData) => {
				this.handleSurveyDefinitions(updatedData)
				if (callback) callback(updatedData)
				return updatedData
			})
			// Return cached data immediately
			return parsedData
		} else {
			// No cache - get fresh data
			const data = await this.getSurveyDefinitionsInternal(survey_id, resp_id, ignoreCache)
			this.handleSurveyDefinitions(data)
			return data
		}
	}

	async getAudience(alt_id) {
		const cacheKey = `audience_${alt_id}`
		const url = `${this.ENDPOINTS.rvu.url}/api/audience/${alt_id}`
		const response = await fetch(url)

		if (!response.ok) {
			throw new Error(`API error: ${response.status} ${response.statusText}`)
		}

		const data = await response.json()
		localStorage.setItem(cacheKey, JSON.stringify(data))
		return data
	}

	async getSurveyDefinitionsInternal(survey_id, resp_id, ignoreCache = true) {
		const cacheKey = `survey_definitions`
		var url = `${this.ENDPOINTS.rvu.url}/api/survey-definitions?survey_id=${survey_id}&resp_id=${resp_id}`
		if (ignoreCache) url += '&ignore_cache=true'
		const response = await fetch(url)
		const data = await response.json()
		localStorage.setItem(cacheKey, JSON.stringify(data))
		return data
	}

	async resetSurvey(survey_id, resp_id) {
		if (!resp_id) {
			console.error('No resp_id provided', resp_id)
			return
		}
		console.warn('Resetting survey:', resp_id)
		const url = `${this.ENDPOINTS.rvu.url}/api/survey-definitions?survey_id=${survey_id}&resp_id=${resp_id}`
		const response = await fetch(url, {
			method: 'DELETE',
		})
		return await response.json()
	}

	async createTravelDay(appInstallationId, travelDay) {
		var body = {
			id: appInstallationId + '+' + travelDay.date,
			appInstallationId: appInstallationId,
			date: travelDay.date,
			data: JSON.stringify(travelDay),
		}
		const response = await fetch(this.ENDPOINTS.travelday.url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json; charset=UTF-8',
				'x-functions-key': this.ENDPOINTS.travelday.key,
			},
			body: JSON.stringify(body),
		})
		return await response.json()
	}

	async getTravelDays(appInstallationId) {
		try {
			const response = await fetch(`${this.ENDPOINTS.travelday.url}/${appInstallationId}`)
			return await response.json()
		} catch (error) {
			return ''
		}
	}

	async getTravelDayById(id, appInstallationId) {
		const response = await fetch(`${this.ENDPOINTS.travelday.url}/${appInstallationId}/${id}`)
		return await response.json()
	}

	async deleteTravelDayById(id, appInstallationId) {
		const response = await fetch(`${this.ENDPOINTS.travelday.url}/${appInstallationId}/${id}`, {
			method: 'DELETE',
		})
		if (response.status == 200) {
			return true
		}
		return false
	}
}

// Create and export a singleton instance
export const dataService = new DataService()
export default dataService
